/** Fragment that scrolls the assisted-capture booking form into view. */
export const VIRTUAL_TOUR_BOOKING_FRAGMENT = 'booking';

/** Route path segments for the supplier Virtual Tour page. */
export const VIRTUAL_TOUR_BOOKING_PATH = ['/virtual-tour'] as const;

export type VirtualTourBookingLink = {
  fragment: string | null;
  queryParams: { factoryId: string } | null;
  routerLink: readonly ['/virtual-tour'];
};

/**
 * Builds router bindings for the assisted VR capture booking page.
 *
 * When `factoryId` is a positive number, deep-links to
 * `/virtual-tour?factoryId={id}#booking`; otherwise `/virtual-tour` only.
 *
 * @example
 * import { virtualTourBookingLink } from '@indutrust/factory-util';
 *
 * const deepLink = virtualTourBookingLink(42);
 * // { routerLink: ['/virtual-tour'], queryParams: { factoryId: '42' }, fragment: 'booking' }
 */
export function virtualTourBookingLink(
  factoryId?: number | null
): VirtualTourBookingLink {
  if (factoryId !== null && factoryId !== undefined && factoryId > 0) {
    return {
      fragment: VIRTUAL_TOUR_BOOKING_FRAGMENT,
      queryParams: { factoryId: String(factoryId) },
      routerLink: VIRTUAL_TOUR_BOOKING_PATH,
    };
  }

  return {
    fragment: null,
    queryParams: null,
    routerLink: VIRTUAL_TOUR_BOOKING_PATH,
  };
}

/**
 * Editor return path for a factory after visiting the booking page with a
 * factory deep link.
 */
export function factoryEditReturnLink(factoryId: number): readonly string[] {
  return ['/factory', String(factoryId), 'edit'];
}
